'use strict'

const PropTypes = require('prop-types')
const types = require('../../types')
const React = require('react')

const CommonSupportFormContainer = require('./common-support-form-container')

class GeneralSupportForm extends React.PureComponent {
  constructor(props) {
    super(props)

    this.enableSubmit = this.enableSubmit.bind(this)
  }

  enableSubmit() {
    const {formData} = this.props
    const requiredFields = ['name', 'subject', 'message', 'email']
    const emptyField = requiredFields.find(field => {
      return !formData.contact[field] || !formData.contact[field].value
    })
    return !emptyField
  }

  render() {
    const {formData, disableUsernameField, onSubmit, showCaptcha} = this.props

    return (
      <div>
        <hr />
        <CommonSupportFormContainer
          onSubmit={onSubmit}
          formData={formData}
          disableUsernameField={disableUsernameField}
          enableSubmit={this.enableSubmit}
          showCaptcha={showCaptcha}
        />
      </div>
    )
  }
}

GeneralSupportForm.propTypes = {
  formData: types.formData.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableUsernameField: PropTypes.bool,
  showCaptcha: PropTypes.bool,
}

module.exports = GeneralSupportForm
